/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
import React, {useEffect,useState} from 'react'
import { useOutletContext, useNavigate, useParams, useLocation } from "react-router-dom";
import { Breadcrumb, Button, Input, Upload, Space, Row, Col, Table, Switch, message, Modal, Divider, Select, DatePicker, Checkbox, Form, Radio, AutoComplete, notification, Popconfirm } from 'antd'
import { UploadOutlined, PlusOutlined, MinusCircleOutlined, EyeOutlined, SendOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import PageTitle from '../components/PageTitle';
import PageLayout from '../components/PageLayout';
import InputPrefix from '../helper/InputPrefix';
import moment from 'moment';
import { fakeGetManagerChainList, getAllWiadvanceUsers, getManagerChainList, getMSId } from '../redux/action/graph';
import SignRecordModal from '../components/SignRecordModal'
import { setSignAndRejectModalVisible, setSignReocrdModalVisible, setViewFileModalVisible, viewFiledata } from '../redux/action/Components';
import SignAndRejectModal from '../components/SignAndRejectModal';
import { canViewUnclosed, getLookupCodeList, getStampDetail, reassignStamp } from '../redux/action/Stamp';
import ViewFileModal from '../components/ViewFileModal';
import { useMsal } from '@azure/msal-react';
import { BrowserView, MobileView } from 'react-device-detect';
import mimeTypeObj from '../helper/mimeTypeObj';
import applyReassignToChain from '../helper/applyReassignToChain';
import FinanceInfoView, { isFinanceDescription } from '../components/FinanceInfoView';

export default function StampOwnerAudit(){

	const { TextArea } = Input
	const dispatch = useDispatch()
	const [form] = Form.useForm()
	const { currentUser } = useOutletContext();
	const { accounts } = useMsal()
	const navigate  = useNavigate()
	const location = useLocation()
	const { id } = useParams()
	// 從「未結案追蹤」進來，返回回到未結案追蹤；否則回待處理
	const backTarget = location.state?.from === 'StampUnclosedTracking' ? '/Stamp/StampUnclosedTracking' : '/Stamp/StampPendingProcessed'
	const [ isDisable, setIsDisable ] = useState(false)
	const [ signoffType, setSignoffType ] = useState('')
	const [ finalManagerList, setFinalManagerList ] = useState([])
	const [ descText, setDescText ] = useState('')
	const [ fileList, setFileList ] = useState([])
	const [ stampOwnerList, setStampOwnerList ] = useState([])
	const stampList = useSelector(state => state.Stamp.stampList)
	const isLoading = useSelector(state => state.globalSetting.isLoading)
	// 轉派（保管人把用印中表單轉給部門同仁代簽）
	const [ reassignOpen, setReassignOpen ] = useState(false)
	const [ allUserList, setAllUserList ] = useState([])
	const [ reassignTarget, setReassignTarget ] = useState(null)
	// 是否為此單目前簽核人(可蓋章) / 是否為保管人或檢視者(可開啟此頁與轉派)
	const [ isAssignee, setIsAssignee ] = useState(false)
	const [ canManage, setCanManage ] = useState(false)

	//呼叫 graph API 取人員資料（轉派對象，同申請頁被代理人下拉）
	useEffect(() =>{
		if(allUserList.length === 0){
			dispatch(getAllWiadvanceUsers()).then(resp =>{
				if(resp && resp.value){
					setAllUserList(resp.value.map(item => ({ label: item.displayName, value: item.mail })))
				}
			})
		}
	}, [])

	//送出轉派
	const onReassign = () =>{
		if(!reassignTarget){
			notification.warning({ message: '提醒', description: '請選擇要轉派的同仁' })
			return
		}
		dispatch(reassignStamp({
			stamp_no: form.getFieldValue('stamp_no'),
			auditor_name: currentUser.name,
			auditor_mail: currentUser.email,
			auditor_type: '印信保管人',
			audit_command: `轉派給 ${reassignTarget.label}`,
			next_auditor_name: reassignTarget.label,
			next_auditor_mail: reassignTarget.value,
		})).then(res =>{
			if(res && res.code === 200){
				notification.success({ message: '成功', description: '已轉派給 ' + reassignTarget.label })
				setReassignOpen(false)
				navigate(backTarget)
			} else {
				notification.error({ message: '失敗', description: res?.messages?.tw || '轉派失敗' })
			}
		}).catch(err =>{
			notification.error({ message: '失敗', description: '轉派失敗（' + (err?.response?.status || '連線/後端錯誤') + '），請確認後端 Reassign API 已部署' })
		})
	}

	useEffect(() =>{
		setIsDisable(true)
		let MSId = accounts[0].localAccountId
		dispatch(canViewUnclosed()).catch(() => false).then(canManageResp =>{
		const canManageNow = !!canManageResp
		setCanManage(canManageNow)
		dispatch(getStampDetail(id)).then(res =>{
			const assignee = res['next_auditor_mail'].split(',').indexOf(currentUser['email']) > -1
			setIsAssignee(assignee)
			if( assignee || canManageNow ){
				dispatch(getMSId(res['applicant_mail'])).then(IdResp =>{
					MSId = IdResp['id']
					dispatch(getManagerChainList(MSId)).then(resp =>{
						let tempManagerNameList =[]
						let tempManagerList = resp
						dispatch(getLookupCodeList('stampType', '')).then(respStampList =>{
							let directLook =respStampList.filter(i=>i?.text3 === 'direct').map(i=>i.lookup_code)
							if (
								// res.stamp_type.indexOf("hsinchuInvoice") > -1 ||
								// res.stamp_type.indexOf("xizhiInvoice") > -1
								res.stamp_type.some(r=> directLook.includes(r))
							){
								// let stampOwner = respStampList.find(
								//   (ele) =>
								//     ele.lookup_code === "hsinchuInvoice" ||
								//     ele.lookup_code === "xizhiInvoice"
								// );
								let stampOwner = respStampList.find(i=>res.stamp_type.includes(i?.lookup_code))

								tempManagerNameList.push({ name: res['applicant_name'], type: '申請人' })
								tempManagerNameList.push({ name: stampOwner['text2'], type: '印信保管人', mail: stampOwner['text1'] })

								tempManagerList = JSON.parse(JSON.stringify(tempManagerNameList))
							}
							else{
								res['stamp_type'].forEach((stampType, index) =>{
									respStampList.forEach(obj =>{
										if(obj.lookup_code === stampType){
											if( tempManagerNameList.indexOf(obj.text2) === -1){
												tempManagerNameList.push(obj.text2)
											}
										}
									})
								})
								tempManagerNameList.forEach(name =>{
									tempManagerList.push({ name: name, type: '印信保管人' })
								})
							}
							setFinalManagerList(applyReassignToChain(tempManagerList, res, respStampList))
						})
						res['cr_date'] = moment.unix(res['cr_date']/1000).format('YYYY/MM/DD HH:mm:ss')
						setStampOwnerList(res['next_auditor_mail'])
						res['file'].map( ele =>{
							let type =''
							let tempUrl = ele
							ele = decodeURI(ele).replace( /\+/g, ' ' )
							ele = ele.split('/')
							ele = ele[ele.length-1]
							type = ele.slice(-3)
							setFileList(prev => [ ...prev, { url: tempUrl, name: ele, type: mimeTypeObj[type] } ])
						})
	
						let signOffTypeList = []
						dispatch(getLookupCodeList('stampType', '')).then(respStampList =>{
							respStampList.forEach(obj =>{
								if( res['stamp_type'].indexOf(obj.lookup_code) > -1 && obj.text1 === currentUser.email ){
									signOffTypeList.push(obj.lookup_code)
								}
							})
							// 被轉派的同仁(此單目前簽核人，但本身非印信保管人) → 代蓋此單所需的印信
							if( signOffTypeList.length === 0 && assignee ){ signOffTypeList = res['stamp_type'] }
							setSignoffType(signOffTypeList)
						})
	
						setDescText(res['description'] || '')
						form.setFieldsValue(res)
					})
				})
			}
			else{
				navigate('/Stamp/StampApplication')
				notification.error({
					message: '錯誤',
					description: '您非此單據的審核人或您已審核過此單據!',
					duration: 6
				})
			}
		})
		})
	}, [])


	//打開檔案瀏覽Modal
	const openViewFileModal = () =>{
		dispatch(viewFiledata(fileList))
		dispatch(setViewFileModalVisible(true))
	}

  return(
		<PageLayout spinning={ isLoading !== 0 ? true : false }>
			<BrowserView>
				{/* 頁面目前位置 */}  
				<Col span={24}>
					<Breadcrumb separator=">">
						<Breadcrumb.Item href='/'>WiAdvance EIP</Breadcrumb.Item>
						<Breadcrumb.Item href="/Stamp/StampApplication">用印申請</Breadcrumb.Item>
						<Breadcrumb.Item href="/Stamp/StampPendingProcessed">待處理</Breadcrumb.Item>
						<Breadcrumb.Item > 用印審核 </Breadcrumb.Item>
					</Breadcrumb>
				</Col>
				{/* 頁面標題 */}
				<PageTitle>
					用印審核
				</PageTitle>
				<Col span={24}>
					<div style={{ backgroundColor:'white'}}>
						<Form
							form={form}
							autoComplete={false}
							style={{ paddingTop: '10px' }}
						>
							{/* 申請單號 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'申請單號'} />
								</Col>  
								<Col span={6} >
									<Form.Item
										name='stamp_no'
									>
										<Input bordered={false}  disabled />
									</Form.Item>
								</Col>
							</Row> 
							{/* 申請人，被代理人申請 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'申請人'} />
								</Col>  
								<Col span={6} >
									<Form.Item
										name='applicant_name'
									>
										<Input bordered={false} disabled={isDisable}/>
									</Form.Item>
								</Col>
								<Col span={8}>
									<Form.Item
										name='is_agent'
										valuePropName="checked"
										style={{ alignItems: 'center' }}
									>
										<Row>
											<Checkbox checked={form.getFieldValue('is_agent') === 'Y' ? true : false} disabled > 被代理人 </Checkbox>
												<Form.Item
													name='agent_name'
													hidden={form.getFieldValue('is_agent') === 'N'}
													style={{ width: '80%', marginBottom: '0' }}
												>
													<Input disabled style={{ width: '80%' }} bordered={false} /> 
											</Form.Item> 
										</Row>
									</Form.Item>
								</Col>
							</Row>
							{/* 簽核印信 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'簽核印信'} />
								</Col>  
								<Col span={6} >
									<Form.Item
										name='stamp_type'
									>
										<Checkbox.Group style={{ width: '100%' }} disabled={isDisable} >
											<Row gutter={[0, 8]}>
											{
												stampList.map( item =>{
													return(
														<>
															<Col span={12}>
																<Checkbox value={item.lookup_code}> {item.description} </Checkbox>
															</Col>
														</>
													)
												})
											}
											</Row>
										</Checkbox.Group>
									</Form.Item>
								</Col>
							</Row>
							{/* 申請日期 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'申請日期'} />
								</Col>  
								<Col span={6} >
									<Form.Item
										name='cr_date'
									>
										<Input bordered={false} disabled/>
									</Form.Item>
								</Col>
							</Row>
							{/* 文件名稱 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'文件名稱'} />
								</Col>
									<Col span={6} >
										<Form.Item
											name='document'
										>
											<TextArea rows={4} maxLength={50} showCount disabled/>
										</Form.Item>
									</Col>
							</Row>
							{/* 內容簡述 / 財務資訊(發票章) */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={ isFinanceDescription(descText) ? '財務資訊' : '內容簡述' } />
								</Col>
								<Col span={ isFinanceDescription(descText) ? 14 : 6 } >
									{ isFinanceDescription(descText) ? (
										<FinanceInfoView description={descText} />
									) : (
										<Form.Item name='description'>
											<TextArea rows={6} maxLength={100} showCount disabled/>
										</Form.Item>
									) }
								</Col>
							</Row>
							{/* 檔案 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'檔案'} />
								</Col>  
								<Col span={6} >
									<Form.Item
										name={'file'}
									>
										<Button onClick={() => openViewFileModal()}> 查看檔案 </Button>
									</Form.Item>
								</Col>
							</Row>
							{/* 簽核流程 */}
							<Row gutter={[24,8]} style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={5}>
									<InputPrefix label={'簽核流程'} />
								</Col>  
								<Col span={19}>
									<Row gutter={[16]}>
										{
											finalManagerList.map((ele, index) =>{
												return(
													<Col style={{ color: ( currentUser.name === ele.name && ele.type === '印信保管人' ? 'blue' : null ), marginTop: ( index > 5  ? '15px' : 0) }} span={4}>
														<p>{ele.type}</p>
														{ele.name}
													</Col>
												)
											})
										}
									</Row>
								</Col>
							</Row>
							<Row justify='end' style={{ color: 'black', paddingBottom: '15px' }}>
								<Col span={3} style={{ padding: '0px 5px' }}>
									<Button type='primary' onClick={() => dispatch(setSignReocrdModalVisible(true))}> 簽核紀錄 </Button>
								</Col>			
								{isAssignee && (
								<Col span={3} style={{ padding: '0px 5px' }}>
									<Button style={{ color: 'white', background: 'blue' }} onClick={() => { dispatch(setSignAndRejectModalVisible(true))} }> 用印簽核 </Button>
								</Col>
								)}
								{(isAssignee || canManage) && (
								<Col span={3} style={{ padding: '0px 5px' }}>
									<Button onClick={() => { setReassignTarget(null); setReassignOpen(true) }}> 轉派 </Button>
								</Col>
								)}
								<Col span={3} style={{ padding: '0px 5px' }}>
									<Button onClick={() => navigate(backTarget)}> 返回 </Button>
								</Col>
							</Row>
						</Form>
					</div>
				</Col>
			</BrowserView>
			<MobileView style={{ marginBottom: '115px' }}>
				{/* 頁面目前位置 */}  
				<Col span={24}>
					<Breadcrumb separator=">">
						<Breadcrumb.Item href='/'>WiAdvance EIP</Breadcrumb.Item>
						<Breadcrumb.Item href="/Stamp/StampApplication">用印申請</Breadcrumb.Item>
						<Breadcrumb.Item href="/Stamp/StampPendingProcessed">待處理</Breadcrumb.Item>
						<Breadcrumb.Item > 用印審核 </Breadcrumb.Item>
					</Breadcrumb>
				</Col>
				{/* 頁面標題 */}
				<PageTitle>
				用印審核
				</PageTitle>
				<Col span={24}>
					<div style={{ backgroundColor:'white'}}>
						<Form
							form={form}
							autoComplete={false}
							labelAlign={'left'}
							labelCol={{ span: 24 }}
						>
							<Row justify='space-around' gutter={[0,8]} style={{ color: 'black', padding: '0 10px 15px 10px' }}>
								{/* 申請單號 */}
								<Col span={24} >
									<Form.Item
										name='stamp_no'
										label='申請單號'
									>
										<Input bordered={false}  disabled />
									</Form.Item>
								</Col> 
								{/* 申請人 */}
								<Col span={24} >
									<Form.Item
										name='applicant_name'
										label='申請人'
									>
										<Input bordered={false} disabled/>
									</Form.Item>
								</Col>
								{/* 被代理人 */}
								<Col span={24}>
									<Form.Item
										name='is_agent'
										valuePropName="checked"
										style={{ alignItems: 'center' }}
									>
										<Row>
											<Checkbox checked={form.getFieldValue('is_agent') === 'Y' ? true : false} disabled > 被代理人 </Checkbox>
												<Form.Item
													name='agent_name'
													hidden={ form.getFieldValue('is_agent') === 'N' }
													style={{ width: '80%', marginBottom: '0' }}
												>
													<Input disabled style={{ width: '80%' }} bordered={false} /> 
											</Form.Item> 
										</Row>
									</Form.Item>
								</Col>
								{/* 簽核印信 */}
								<Col span={24} >
									<Form.Item
										label='簽核印信'
										name='stamp_type'
									>
										<Checkbox.Group style={{ width: '100%' }} disabled >
											<Row style={{ padding: '0 20px' }} justify='center' gutter={[0, 8]}>
												{
													stampList.map( item =>{
														return(
															<>
																<Col span={12}>
																	<Checkbox value={item.lookup_code}> {item.description} </Checkbox>
																</Col>
															</>
														)
													})
												}
											</Row>
										</Checkbox.Group>
									</Form.Item>
								</Col>
								{/* 申請日期 */}
								<Col span={24}>
									<Form.Item
										label='申請日期'
										name={'cr_date'}
									>
										<Input bordered={false} disabled/>
									</Form.Item>
								</Col>
								{/* 文件名稱 */}
								<Col span={24} >
									<Form.Item
										name='document'
										label='文件名稱'
									>
										<TextArea rows={4} maxLength={50} showCount disabled/>
									</Form.Item>
								</Col>
								{/* 內容簡述 / 財務資訊(發票章) */}
								<Col span={24} >
									{ isFinanceDescription(descText) ? (
										<>
											<div style={{ fontWeight: 600, color: 'black', marginBottom: '6px' }}>財務資訊</div>
											<FinanceInfoView description={descText} />
										</>
									) : (
										<Form.Item name='description' label='內容簡述'>
											<TextArea rows={6} maxLength={100} showCount disabled/>
										</Form.Item>
									) }
								</Col>
								{/* 檔案 */}
								<Col span={24}>
									<span style={{ color:'black', fontWeight: 600, fontSize: '16px' }}> 檔案 </span>
								</Col>
								<Col span={24}>
									<Form.Item
										name={'file'}
									>
										<Button onClick={() => openViewFileModal('apply')}> 查看申請檔案 </Button>
									</Form.Item>
								</Col>
								{/* 簽核流程 */}
								<Col span={24}>
									<span style={{ color:'black', fontWeight: 600, fontSize: '16px' }}> 簽核流程 </span>
								</Col>  
								<Col span={24} style={{ marginBottom: '15px' }}>
									<Row gutter={[10, 30]}>
										{
											finalManagerList.map((ele, index) =>{
												return(
													<Col style={{ color: ( currentUser.name === ele.name && ele.type === '印信保管人' ? 'blue' : null ), marginTop: ( index > 2  ? '15px' : 0) }} span={8}>
														<p>{ele.type}</p>
														{ele.name}
													</Col>
												)
											})
										}
									</Row>
								</Col>
								{/* 按鈕 */}
								<Col span={8} style={{ padding: '0px 5px' }}>
									<Button onClick={() => navigate(backTarget)}> 返回 </Button>
              	</Col> 
								<Col span={8} style={{ padding: '0px 5px' }}>
									<Button type='primary' onClick={() => dispatch(setSignReocrdModalVisible(true))}> 簽核紀錄 </Button>
								</Col>
								{isAssignee && (
								<Col span={8} style={{ padding: '0px 5px' }}>
									<Button style={{ color: 'white', background: 'blue' }} onClick={() => { dispatch(setSignAndRejectModalVisible(true))} }> 用印簽核 </Button>
								</Col>
								)}
								{(isAssignee || canManage) && (
								<Col span={8} style={{ padding: '0px 5px' }}>
									<Button onClick={() => { setReassignTarget(null); setReassignOpen(true) }}> 轉派 </Button>
								</Col>
								)}
							</Row>
						</Form>
					</div>
				</Col>
			</MobileView>
		<ViewFileModal />
		<SignRecordModal />
		<SignAndRejectModal stampOwnerList={stampOwnerList} type={signoffType} status={'pendingStamp'}/>
		<Modal
			title='轉派給同仁'
			visible={reassignOpen}
			onOk={onReassign}
			onCancel={() => setReassignOpen(false)}
			okText='確定轉派'
			cancelText='取消'
		>
			<p style={{ color: '#7C7C7C' }}>選擇部門同仁代為簽核蓋章，轉派後此單將出現在對方的待處理。</p>
			<Select
				showSearch
				style={{ width: '100%' }}
				placeholder='請選擇同仁'
				value={reassignTarget?.value}
				options={allUserList}
				onSelect={(_, option) => setReassignTarget(option)}
				filterOption={(input, option) => {
					if(input.search(/^[A-Za-z0-9]*$/) === 0){
						return (option?.label ?? '').toLowerCase().startsWith(input.toLowerCase())
					}
					return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
				}}
			/>
		</Modal>
	</PageLayout>
	)
}